import { useQuery } from '@tanstack/react-query'
import { createFileRoute } from '@tanstack/react-router'
import { Card, CardContent } from '@/components/ui/card'
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from '@/components/ui/table'
import { orpc } from '@/lib/orpcClient'

export const Route = createFileRoute('/hr/me/attendance')({
  component: MyAttendancePage,
})

function MyAttendancePage() {
  const { data, isLoading } = useQuery(orpc.hr.me.listOwnAttendance.queryOptions({ input: {} }))
  const rows = (data ?? []) as Array<{
    id: number
    date: string
    status: string
    checkIn: string | null
    checkOut: string | null
  }>

  return (
    <Card>
      <CardContent className="p-0">
        {isLoading ? (
          <div className="p-6 text-muted-foreground">Loading...</div>
        ) : rows.length === 0 ? (
          <div className="p-6 text-muted-foreground">No attendance records yet.</div>
        ) : (
          <Table>
            <TableHeader>
              <TableRow>
                <TableHead>Date</TableHead>
                <TableHead>Status</TableHead>
                <TableHead>Check-in</TableHead>
                <TableHead>Check-out</TableHead>
              </TableRow>
            </TableHeader>
            <TableBody>
              {rows.map((r) => (
                <TableRow key={r.id}>
                  <TableCell>{new Date(r.date).toLocaleDateString()}</TableCell>
                  <TableCell>{r.status}</TableCell>
                  <TableCell>{r.checkIn ?? '-'}</TableCell>
                  <TableCell>{r.checkOut ?? '-'}</TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        )}
      </CardContent>
    </Card>
  )
}
